<template>
  <div class="card-novos-termos full-size-or-desktop-card">
    <div class="card-novos-termos__icon-circle">
      <img class="card-novos-termos__icon" :src="iconSrc" alt="">
    </div>

    <h1 class="card-novos-termos__title">
      {{ cardTitle }}
    </h1>

    <div class="card-novos-termos__body">
      <slot />
    </div>

    <button
      type="button"
      class="card-novos-termos__button"
      :class="{ 'card-novos-termos__button--inter': isInterTheme }"
      :disabled="btnDisabled"
      @click="$emit('click')"
    >
      {{ btnText }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import theme from '@/services/ThemeService';

export default defineComponent({
  props: {
    iconSrc: {
      type: String,
      required: true,
    },
    cardTitle: {
      type: String,
      required: true,
    },
    btnDisabled: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      required: true,
    },
  },
  emits: ['click'],
  setup() {
    return {
      isInterTheme: theme.isInterTheme(),
    };
  },
});
</script>

<style lang="scss" scoped>
@use "@/assets/styles/functions.scss" as *;

.card-novos-termos__icon-circle {
  padding: 8px;
  margin-bottom: 8px;
  background-color: #FFEFCD;
  width: min-content;
  border-radius: 50%;

  .card-novos-termos__icon {
    display: block;
    width: 32px;
    height: 32px;
  }
}

.card-novos-termos__title {
  font-size: px2rem(20px);
  line-height: 1.5;
  margin: 0 0 1rem;
}

.card-novos-termos__text {
  font-size: px2rem(14px);
}

.card-novos-termos__button {
  font-size: px2rem(16px);
  font-weight: 600;
  color: black;
  background-color: var(--secondary-color-normal);
  width: 100%;
  margin-top: 1rem;
  padding: 12px 24px;
  border: none;
  border-radius: 5px;
  transition: all .3s;

  &:hover {
    background-color: var(--secondary-color-dark);
  }

  &[disabled] {
    background-color: var(--disabled-color-normal);
  }

  &.card-novos-termos__button--inter {
    color: var(--button-main-text, white);
    background-color: var(--primary-color-normal);

    &:hover {
      background-color: var(--button-main-hover-bg, var(--primary-color-dark));
    }

    &[disabled] {
      background-color: var(--disabled-color-normal);
    }
  }
}
</style>
